const designNav = (() => {
  const pageDesign = (document.getElementById("pageDesign") != null);
  if (pageDesign) {



    let sW = window.innerWidth;

    let secNav = document.querySelector('#jsSecNav');
    let navWrap = secNav.querySelector('.js-nav-wrap');
    let numBoxs = secNav.querySelectorAll('.js-num-box');
    let secCntnts = document.querySelectorAll('.js-sec-cntnt');


    let tl = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: navWrap,
        endTrigger: secCntnts[secCntnts.length - 1],
        start: '0% 0%',
        end: '100% 100%',
        pin: true,
        pinSpacing: false,
        // markers: true,
      }
    })


    let setStart
    let setEnd
    if (sW > 750) {
      setStart = "0% 0%";
      setEnd = "100% 0%";
    } else {
      setStart = "0% 50%";
      setEnd = "100% 50%";
    }

    let tl0 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[0],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[0], className: "act" },
        // markers: true,
      },
    })
    let tl1 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[1],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[1], className: "act" },
        // markers: true,
      },
    })
    let tl2 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[2],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[2], className: "act" },
        // markers: true,
      },
    })
    let tl3 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[3],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[3], className: "act" },
        // markers: true,
      },
    })
    let tl4 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[4],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[4], className: "act" },
        // markers: true,
      },
    })
    let tl5 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[5],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[5], className: "act" },
        // markers: true,
      },
    })
    let tl6 = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: secCntnts[6],
        start: setStart,
        end: setEnd,
        toggleClass: { targets: numBoxs[6], className: "act" },
        // markers: true,
      },
    })


    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        tl.scrollTrigger.refresh()
        tl0.scrollTrigger.refresh()
        tl1.scrollTrigger.refresh()
        tl2.scrollTrigger.refresh()
        tl3.scrollTrigger.refresh()
        tl4.scrollTrigger.refresh()
        tl5.scrollTrigger.refresh()
        tl6.scrollTrigger.refresh()
      });
    });
    observer.observe(target);



  }
})();
export default designNav;